import React, { useContext, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { Helmet } from 'react-helmet';
import './Header.css';
import './HeaderScroll';

const Header = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Check if current path should be indexed
  // Only index the home page (/) and pages with pattern /p/*
  const shouldIndex = location.pathname === '/' || location.pathname.startsWith('/p/');

  return (
    <>
      <Helmet>
        {!shouldIndex && <meta name="robots" content="noindex" />}
      </Helmet>
      {/* Rest of your header content */}
    </>
  )
};

export default Header;
